<template>
	<ValidationProvider
		:vid="`${computedName}-${index + generatedId}`"
		:name="options.label"
		:rules="options.rules"
		v-slot="{ errors }"
		slim
	>
		<div :class="['d-intable chbox_style-wrapper', options.wrapperClass]" @click="$emit('click', $event)">
			<div :class="[options.className]">
				<label
					:class="options.tooltip ? 'label mb-8px radio-tooltip ' : 'label mb-8px d-table'"
					v-if="hasLabel"
				>
					{{ options.label }}
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</label>
				<div class="d-block">
					<span :class="[options.inputWrapperClass, { disabled: disabled }]">
						<div v-for="(choice, index) in options.choices" :key="index" class="d-block py-15px">
							<input
								type="radio"
								:name="options.name + generatedId"
								:value="computedValue(index)"
								:id="index + generatedId"
								class="d-none"
								v-model="computedVModel"
								data-hj-allow
							/>
							<span class="chbox_style"></span>
							<label :for="index + generatedId" :class="[options.inputclass, { disabled: disabled }]">
								<span class="d-block ml-34px">{{ choice }}</span>
							</label>
						</div>
					</span>
				</div>
				<span :class="['error_message error_message--broke', options.className]">{{ errors[0] }}</span>
			</div>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

export default {
	mixins: [shared],
	computed: {
		...mapGetters('contracting', ['getCheckboxData']),
		hasLabel() {
			return !_.has(this.options, 'hasLabel') ? true : this.options.hasLabel;
		},
		computedVModel: {
			get() {
				return this.getData();
			},
			set(value) {
				this.handleCheck(value);
			},
		},
	},
	methods: {
		...mapMutations('contracting', ['setCheckboxData']),
		getData() {
			if (this.type === 'calculation') {
				return this.getStateData(this.options.prop);
			}

			if (this.type === 'contracting') {
				return this.getCheckboxData(this.options.prop, this.options?.group, this.options?.insurer);
			}
		},
		handleCheck(value) {
			if (this.type === 'calculation') {
				this.setStateData({ prop: this.options.prop, value });

				if (_.has(this.options, 'event')) {
					this.$store.commit(this.options.event);
				}
			}

			if (this.type === 'contracting') {
				this.setCheckboxData({
					group: this.options?.group,
					insurer: this.options?.insurer,
					prop: this.options.prop,
					value,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.disabled {
	input {
		cursor: not-allowed;
		pointer-events: none;
	}

	label {
		cursor: not-allowed;
		pointer-events: none;

		span:not(.info) {
			pointer-events: none;
		}
	}

	.chbox_style {
		background-color: #ccc;

		&::before {
			border-bottom: 3px solid #777778 !important;
			border-right: 3px solid #777778 !important;
		}
	}
}
</style>
